import { createBrowserRouter, type RouteObject } from 'react-router-dom';
import { LandingPage } from '../features/landing/LandingPage';
import { ScenePlayerPage } from '../features/scenePlayer/ScenePlayerPage';
import { ResultPage } from '../features/resultReport/ResultPage';
import { ChallengePage } from '../features/challenge/ChallengePage';
import { ComparePage } from '../features/compare/ComparePage';
import { HowItWorksPage } from '../features/howItWorks/HowItWorksPage';
import { TypeAtlasPage, TypeDetailPage } from '../features/typeAtlas/TypeAtlasPage';

export const appRoutes: RouteObject[] = [
  { path: '/', element: <LandingPage /> },
  { path: '/zh/', element: <LandingPage forcedLocale="zh-CN" /> },
  { path: '/en/', element: <LandingPage forcedLocale="en" /> },
  { path: '/zh/how-it-works/', element: <HowItWorksPage locale="zh-CN" /> },
  { path: '/en/how-it-works/', element: <HowItWorksPage locale="en" /> },
  { path: '/zh/types/', element: <TypeAtlasPage locale="zh-CN" /> },
  { path: '/en/types/', element: <TypeAtlasPage locale="en" /> },
  { path: '/zh/types/:typeId/', element: <TypeDetailPage locale="zh-CN" /> },
  { path: '/en/types/:typeId/', element: <TypeDetailPage locale="en" /> },
  { path: '/play', element: <ScenePlayerPage /> },
  { path: '/result', element: <ResultPage /> },
  { path: '/challenge', element: <ChallengePage /> },
  { path: '/challenge/play', element: <ScenePlayerPage mode="challenge" /> },
  { path: '/compare', element: <ComparePage /> }
];

export const router = createBrowserRouter(appRoutes);
